import { useMemo } from 'react';
import { EmploymentType, EmploymentNeed } from '../types';

export const employmentOptions: {
    value: EmploymentType;
    needs: EmploymentNeed;
}[] = [
    {
        value: 'FAST_ANSTALLD',
        needs: {
            applicantEmployer: true,
            applicantEmploymentYearFrom: true,
            applicantEmploymentMonthFrom: true,
        },
    },
    {
        value: 'VIKARIAT',
        needs: {
            applicantEmployer: true,
            applicantEmploymentYearFrom: true,
            applicantEmploymentMonthFrom: true,
            applicantEmploymentYearUntil: true,
            applicantEmploymentMonthUntil: true,
            employmentTypeQualifying: true,
        },
    },
    {
        value: 'EGEN_FORETAGARE',
        needs: {
            applicantEmployer: true,
            applicantEmploymentYearFrom: true,
            applicantEmploymentMonthFrom: true,
        },
    },
    {
        value: 'PENSIONAR',
        needs: {
            applicantEmploymentYearFrom: true,
            applicantEmploymentMonthFrom: true,
        },
    },
    {
        value: 'ARBETSLOS',
        needs: {},
    },
];

const prefixFieldNames = (needs: EmploymentNeed, prefix: 'coapplicant') => {
    const prefixed: EmploymentNeed = {};

    Object.keys(needs).forEach(key => {
        let newKey: string;

        if (key.startsWith('applicant')) {
            newKey = key.replace(/applicant/, prefix);
        } else if (key === 'employmentTypeQualifying') {
            newKey = `${prefix}EmploymentTypeQualifying`;
        } else {
            newKey = key;
        }

        prefixed[newKey as keyof EmploymentNeed] = true;
    });

    return prefixed;
};

export const useEmploymentFields = (type: EmploymentType | undefined, coApplicant = false) => {
    const active = useMemo(() => {
        if (!type) {
            return {};
        }
        const option = employmentOptions.find(o => o.value === type);
        const needs = option?.needs ?? {};

        // If it's for co-applicant, prefix all field names with 'coApplicant'
        if (coApplicant) {
            return prefixFieldNames(needs, 'coapplicant');
        }

        return needs;
    }, [type, coApplicant]);

    return { active, options: employmentOptions };
};
